import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as proposalPersonnel from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: proposalPersonnel.RESOURCE.payload.dimension.partialId,
      partialId: proposalPersonnel.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The type of relationship between a proposal and an employee, such as proposal leader or team member',
    isOptional: true,
    name: 'Type',
    partialId: PartialId.Standard.create('type'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
